/*
|-------------------------------------------------------------------------------
| VUEX modules/bookings.js
|-------------------------------------------------------------------------------
| The Vuex data store for the cafes

status = 0 -> data hasn't been loaded
status = 1 -> data is loading
status = 2 -> data is loaded successfully
status = 3 -> data is loaded unsuccessfully
*/

import TruckAPI from '../api/truck.js';

export const trucks = {
    state: {
        trucks: [],
        trucksLoadStatus: 0,
    },

    actions: {
        loadTrucks( {commit}, params ) {
            return new Promise((resolve, reject) => {
                commit('setTrucksLoadStatus', 1);

                TruckAPI.getTrucks( params )
                    .then(response => {
                        commit('setTrucks', response.data.data);
                        commit('setTrucksLoadStatus', 2);
                        resolve();
                    })
                    .catch(() => {
                        commit('setTrucks', []);
                        commit('setTrucksLoadStatus', 3);
                        reject();
                    });
            });
        },
    },

    mutations: {
        setTrucks( state, rawTrucks ){
            state.trucks = rawTrucks.map(rawTruck => mapToTruck(rawTruck));
        },
        setTrucksLoadStatus( state, status ){
            state.trucksLoadStatus = status;
        },
    },

    getters: {
        getTrucks(state) {
            return state.trucks.sort(function(a, b) {
                var plateA = a.plate.toUpperCase(); // ignore upper and lowercase
                var plateB = b.plate.toUpperCase(); // ignore upper and lowercase
                if (plateA < plateB) {
                    return -1;
                }
                if (plateA > plateB) {
                    return 1;
                }
                return 0;
            });
        },
        getTrucksLoadStatus(state) {
            return state.trucksLoadStatus;
        },
    },
};

/**
 * Helpers
 */
function mapToTruck (rawTruck) {
    return {
        id: rawTruck.id,
        plate: rawTruck.plate,
        detailedPlate: rawTruck.detailed_plate,
    }
}

